import { render, staticRenderFns } from "./ClientEditFormFields.vue?vue&type=template&id=516bd627"
import script from "./ClientEditFormFields.vue?vue&type=script&lang=js"
export * from "./ClientEditFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports